export default "__VITE_ASSET__Dn43D60u__"